// ==========================================================================
// CACTUS KNIGHT — Share-Button
// Nutzt die native Web-Share-API (z. B. auf Handys: "An... senden"-Menü),
// falls der Browser sie unterstützt. Andernfalls wird der Link in die
// Zwischenablage kopiert und kurz bestätigt.
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".share-btn").forEach((btn) => {
    const toast = document.createElement("span");
    toast.className = "share-btn__toast";
    toast.textContent = "Link kopiert!";
    btn.appendChild(toast);

    btn.addEventListener("click", async () => {
      const relativeUrl = btn.dataset.shareUrl || window.location.href;
      const absoluteUrl = new URL(relativeUrl, window.location.href).href;
      const title = btn.dataset.shareTitle || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title, url: absoluteUrl });
          return;
        } catch (err) {
          // Nutzer hat abgebrochen oder API nicht verfügbar -> Fallback unten
        }
      }

      try {
        await navigator.clipboard.writeText(absoluteUrl);
      } catch (err) {
        // Fallback für ältere Browser ohne Clipboard-API
        const tempInput = document.createElement("input");
        tempInput.value = absoluteUrl;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }

      toast.classList.add("is-visible");
      setTimeout(() => toast.classList.remove("is-visible"), 1800);
    });
  });
});
